export var DeviceInfoType;
(function (DeviceInfoType) {
    DeviceInfoType["DESKTOP"] = "desktop";
    DeviceInfoType["MOBILE"] = "mobile";
    DeviceInfoType["TABLET"] = "tablet";
    DeviceInfoType["CONSOLE"] = "console";
    DeviceInfoType["SMARTTV"] = "smarttv";
    DeviceInfoType["WEARABLE"] = "wearable";
    DeviceInfoType["XR"] = "xr";
    DeviceInfoType["EMBEDDED"] = "embedded";
    DeviceInfoType["UNKNOWN"] = "unknown";
})(DeviceInfoType || (DeviceInfoType = {}));
export var LoginMethod;
(function (LoginMethod) {
    LoginMethod["PASSWORD"] = "password";
    LoginMethod["OAUTH"] = "oauth";
    LoginMethod["MAGIC_LINK"] = "magic_link";
})(LoginMethod || (LoginMethod = {}));
export var LoginStatus;
(function (LoginStatus) {
    LoginStatus["SUCCESS"] = "success";
    LoginStatus["FAILED"] = "failed";
})(LoginStatus || (LoginStatus = {}));
export var FailureReason;
(function (FailureReason) {
    FailureReason["INVALID_PASSWORD"] = "invalid_password";
    FailureReason["USER_DOESNT_EXIST"] = "user_doesnt_exist";
    FailureReason["USER_HAS_NO_PASSWORD"] = "user_has_no_password";
    FailureReason["UNKNOWN"] = "unknown";
})(FailureReason || (FailureReason = {}));
